import * as React from 'react';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import ReservationSuccessModalStore from './store';

const styles = require('./index.less');

export const ReservationSuccessMessage = ({ account, serverName, friends }) => (
  <div className={styles.content}>
    <p style={{ marginTop: '60px' }}>
      账号<span>{account || '当前账号'}</span>已成功预约生态服【<span>{serverName}</span>】
      {friends.length > 0 && (
        <React.Fragment>
          您的好友<span>{friends.join('、')}</span>等多位好友也成功参与新服预约。
        </React.Fragment>
      )}
    </p>
  </div>
);

const ReservationSuccessModal = ({ store, onClose }) => {
  store.use();
  store.onClose = onClose;
  return (
    <ModalContainer modalState={store.isOpen}>
      <section className={styles.panel} aria-label="预约成功">
        <button className={styles.close} type="button" aria-label="关闭" onClick={store.onClickClose}>
          <span>关闭</span>
        </button>
        <div className={styles.surface}>
          <ReservationSuccessMessage account={store.account} serverName={store.serverName} friends={store.friends} />
          <div className={styles.envelope} />
          <button className={styles.confirm} type="button" onClick={store.onClickClose}>
            <span>确定</span>
          </button>
        </div>
      </section>
    </ModalContainer>
  );
};

export default wrapStore(ReservationSuccessModal, ReservationSuccessModalStore);
